import { WhoSubmitter } from '../../lib/who/who-submit.service'
import { DocsWhoSubmittter } from './docs-who-submit.service'

export const PROVIDERS = [
  {
    provide: WhoSubmitter,
    useClass: DocsWhoSubmittter,
  }
]
